import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Création du client React Query
const queryClient = new QueryClient();

// Point d’entrée de l’application
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    {/* Tu peux réactiver StrictMode si tu veux */}
    {/* <React.StrictMode> */}
      <App />
    {/* </React.StrictMode> */}
  </QueryClientProvider>
);

// Facultatif : pour mesurer les performances
reportWebVitals();
